// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__KR8X0","active":"tabs_active__GbhZb","tabcontent":"tabs_tabcontent__H9L8A"};